<template>
	<ValidationProvider :vid="`${computedName}-${index + generatedId}`" :name="options.label" :rules="options.rules"
		v-slot="{ errors, classes }" slim>
		<div :class="['d-intable', options.wrapperClass]">
			<div :class="[options.className]">
				<label :class="options.tooltip ? 'label mb-8px radio-tooltip ' : 'label mb-8px d-table'" v-if="hasLabel">
					{{ options.label }}
					<span v-if="options.tooltip" v-tooltip="options.tooltipText" class="info"></span>
				</label>
				<div class="d-flex radio-wrapper">
					<span ref="group" class="d-flex radio-field" :class="[classes, options.inputWrapperClass]" role="radiogroup">
						<div role="radio" tabindex="0" @keydown="handleKeydown" v-for="(choice, index) in options.choices"
							:key="index">
							<input :type="options.type" :name="options.name + generatedId" :value="computedValue(index)"
								:id="index + generatedId" class="d-none" v-model="computedVModel" data-hj-allow />
							<label :for="index + generatedId" :class="['radioBtn', options.inputclass]"
								@click="$emit('click', computedValue(index))">
								{{ choice }}
							</label>
						</div>
					</span>
				</div>
				<span :class="['error_message error_message--broke', options.className]">{{ errors[0] }}</span>
			</div>
		</div>
	</ValidationProvider>
</template>

<script>
import shared from '@/mixins/shared';
import _ from 'lodash';

export default {
	mixins: [shared],
	data() {
		return {
			firstRadioButton: null,
			lastRadioButton: null,
			radioButtons: [],
		}
	},
	mounted() {
		const radioButtons = this.$refs.group.querySelectorAll('[role=radio]');

		for (var i = 0; i < radioButtons.length; i++) {
			var rb = radioButtons[i];

			rb.tabIndex = -1;
			rb.setAttribute('aria-checked', 'false');

			this.radioButtons.push(rb);

			if (!this.firstRadioButton) {
				this.firstRadioButton = rb;
			}
			this.lastRadioButton = rb;
		}
		this.firstRadioButton.tabIndex = 0;
	},
	computed: {
		computedVModel: {
			get() {
				return this.getDataByGroup(this.options.inputGroup, this.index)[this.name];
			},
			set(value) {
				this.setInputData({ group: this.options.inputGroup, key: this.name, value: value, index: this.index });
			},
		},
		hasLabel() {
			return !_.has(this.options, 'hasLabel') ? true : this.options.hasLabel;
		},
	},
	methods: {
		handleKeydown(event) {
			let tgt = event.currentTarget,
				flag = false;

			switch (event.key) {
				case ' ':
				case 'Enter':
					this.setChecked(tgt);
					flag = true;
					break;

				case 'Up':
				case 'ArrowUp':
				case 'Left':
				case 'ArrowLeft':
					this.setCheckedToPreviousItem(tgt);
					flag = true;
					break;

				case 'Down':
				case 'ArrowDown':
				case 'Right':
				case 'ArrowRight':
					this.setCheckedToNextItem(tgt);
					flag = true;
					break;

				default:
					break;
			}

			if (flag) {
				event.stopPropagation();
				event.preventDefault();
			}
		},
		setFocus(currentItem) {
			currentItem.setAttribute('aria-checked', 'true');
			currentItem.tabIndex = 0;
			currentItem.focus();
		},
		setChecked(currentItem) {
			for (let i = 0; i < this.radioButtons.length; i++) {
				const rb = this.radioButtons[i];
				rb.setAttribute('aria-checked', 'false');
				rb.tabIndex = -1;
			}
			
			this.setFocus(currentItem);
			const input = currentItem.querySelector('input');
			this.computedVModel = this.computedValue(input.value);
		},
		setCheckedToPreviousItem(currentItem) {
			let index;

			if (currentItem === this.firstRadioButton) {
				this.setFocus(this.lastRadioButton);
			} else {
				index = this.radioButtons.indexOf(currentItem);
				this.setFocus(this.radioButtons[index - 1]);
			}
		},
		setCheckedToNextItem(currentItem) {
			let index;

			if (currentItem === this.lastRadioButton) {
				this.setFocus(this.firstRadioButton);
			} else {
				index = this.radioButtons.indexOf(currentItem);
				this.setFocus(this.radioButtons[index + 1]);
			}
		}
	}
};
</script>
